import { render, staticRenderFns } from "./passCom.vue?vue&type=template&id=2a5d670f&scoped=true&"
import script from "./passCom.vue?vue&type=script&lang=js&"
export * from "./passCom.vue?vue&type=script&lang=js&"
import style0 from "./passCom.vue?vue&type=style&index=0&id=2a5d670f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d670f",
  null
  
)

component.options.__file = "passCom.vue"
export default component.exports